const parseEnvNumber = (value: string | undefined, fallback: number): number => {
  if (value == null || value === '') return fallback;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

/** Brand buId / appId from env — override per environment in .env.* files */
export const BRAND_ENV = {
  student: {
    buId: parseEnvNumber(process.env.REACT_APP_STUDENT_BU_ID, 1),
    appId: parseEnvNumber(process.env.REACT_APP_STUDENT_APP_ID, 2),
  },
  hale: {
    buId: parseEnvNumber(process.env.REACT_APP_HALE_BU_ID, 1),
    appId: parseEnvNumber(process.env.REACT_APP_HALE_APP_ID, 2),
  },
} as const;

export const STUDENT_BU_ID = BRAND_ENV.student.buId;
export const STUDENT_APP_ID = BRAND_ENV.student.appId;
export const HALE_BU_ID = BRAND_ENV.hale.buId;
export const HALE_APP_ID = BRAND_ENV.hale.appId;
